/**
 * The four possible rotation angles for a picture in the CCropper
 */
export enum ImageCropperRotationDegrees {
  Zero = 0,
  Ninety = 90,
  OneEigthy = 180,
  TwoSeventy = 270
}
